import { useMemo, useState } from 'react';
import SectionHeading from '@/pages/home/components/SectionHeading';
import { filmCategories, filmItems } from '@/mocks/cinemaData';

export default function FilmGuideSection() {
  const [active, setActive] = useState('全部');

  const list = useMemo(
    () => (active === '全部' ? filmItems : filmItems.filter((item) => item.category === active)),
    [active],
  );

  return (
    <section id="films" className="bg-background-100 py-16 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="影片导览"
          title="按分类快速找到想看的类型"
          desc="不同平台的片单会随时调整，这里用一组示例条目说明内容是如何按类型组织的。点击下方分类标签即可在本页内筛选，全部为本地展示数据。"
        />

        <div
          className="mt-8 flex flex-wrap gap-2"
          role="tablist"
          aria-label="影片分类筛选"
        >
          {filmCategories.map((category) => {
            const selected = active === category;
            return (
              <button
                key={category}
                type="button"
                role="tab"
                aria-selected={selected}
                onClick={() => setActive(category)}
                className={`whitespace-nowrap rounded-full px-4 py-2 text-sm transition-colors ${
                  selected
                    ? 'bg-primary-500 font-medium text-background-50'
                    : 'border border-background-300 bg-background-50 text-foreground-600 hover:border-primary-300 hover:text-foreground-900'
                }`}
              >
                {category}
              </button>
            );
          })}
        </div>

        <p className="mt-4 text-sm text-foreground-500" aria-live="polite">
          当前展示 <span className="font-medium text-foreground-900">{list.length}</span> 条 · 分类：{active}
        </p>

        <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {list.map((film) => (
            <article
              key={film.title}
              className="group overflow-hidden rounded-lg border border-background-200 bg-background-50"
            >
              <div className="relative aspect-[3/4] w-full overflow-hidden">
                <img
                  src={film.img}
                  alt={`${film.title} 影片封面示意`}
                  title={`${film.title} 影片封面 · 秋霞影院在线观看 影片导览`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.03]"
                />
                <span className="absolute left-3 top-3 rounded-full bg-background-50/90 px-2.5 py-1 text-xs font-medium text-primary-700">
                  {film.category}
                </span>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-base font-semibold text-foreground-950">{film.title}</h3>
                <p className="mt-1 text-xs text-foreground-500">{film.meta}</p>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{film.desc}</p>
              </div>
            </article>
          ))}
        </div>

        <p className="mt-6 text-xs leading-relaxed text-foreground-500">
          说明：以上条目为帮助理解内容组织方式的示例，用于展示分类与卡片结构，不代表任何具体平台的实时片单。
        </p>
      </div>
    </section>
  );
}